__webpack_require__.p = "/courses/object-oriented-analysis-and-design/";